import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Home from '../components/Home';
// import About from '../components/About/About';
import { ApiProvider } from '../context/apiContext';
import '../styles/base.css';
import './styles.css'

const RouterDOM = () => {

	// Determine the initial API type based on the path
	const determineApiType = () => {
		const path = window.location.pathname;
		if (path.startsWith('/v1')) return 'databricks';
		if (path.startsWith('/v2')) return 'postgres';
		return 'postgres'; // Default to Databricks if path is not specified
	};

	const initialApiType = determineApiType();

	return (
		<ApiProvider initialApiType={initialApiType}>
			<Router>
				<Switch>
					<Route exact path="/"><Home /></Route>
					<Route exact path="/home"><Home /></Route>
					{/* <Route exact path="/about"><About /></Route> */}
				</Switch>
			</Router>
		</ApiProvider>
	);
}
export default RouterDOM;